import React from 'react';
import { scroller } from 'react-scroll';

export default function HeroSection() {
    const scrollToContact = () => {
        scroller.scrollTo('Contact', {
            duration: 800,
            delay: 0,
            smooth: 'easeInOutQuart'
        });
    };
    return (
        <section id="heroSection" className="hero--section">
            <div className="hero--section--content--box">
                <div className="hero--section--content">
                    {/* <p className="section--title">This is,</p> */}
                    <h1 className="hero--section--title" data-aos="fade-up" data-aos-offset="300" data-aos-easing="ease-in-sine">
                        <span className="hero--section-title--color">Hey, I'm Samrudhi</span>
                        {/* {" "}
                        <br/>
                        I build things for the web. */}
                    </h1>
                    <p className="hero--section-description text-white" data-aos="fade-left" data-aos-offset="300" data-aos-easing="ease-in-sine">Experienced Frontend Developer specialized in Responsive Web Design (RWD), HTML5, CSS3, Sass, jQuery, Bootstrap, JavaScript, React.js, Tailwind, and many more web tools.
                    Delivered 100+ websites with a 99% on-time rate.
                    </p>
                    <button className="btn btn-outline-primary" onClick={scrollToContact} data-aos="fade-down" data-aos-offset="300" data-aos-easing="ease-in-sine">Get In Touch</button>
                </div>
            </div>
            {/* <div className="hero--section--img hero--section-col">
                <img src="./img/image-1.png" alt="hero section" />
            </div> */}
        </section>
    );
}